import { useEffect, useState } from "react";
import { Moon, Star } from "lucide-react";
import { PhotoDialog, PhotoHeart } from "@/components/ProfilePhotos";
import { api } from "@/lib/api";
import { imgSrc } from "@/lib/categories";

export function LastNightPhotos({ city }) {
  const [data, setData] = useState({ window: "", photos: [] });
  const [open, setOpen] = useState(null);
  useEffect(() => {
    let live = true;
    setData({ window: "", photos: [] });
    api.get("/photos/last-night", { params: { city } }).then((r) => live && setData(r.data)).catch(() => {});
    return () => { live = false; };
  }, [city]);
  const onLiked = (url, d) => {
    setData((s) => ({ ...s, photos: s.photos.map((x) => (x.url === url ? { ...x, ...d } : x)) }));
    setOpen((o) => (o && o.url === url ? { ...o, ...d } : o));
  };
  if (!data.photos.length) return null;
  const short = city.split(",")[0];

  return (
    <section data-testid="last-night-photos" className="mb-8">
      <h3 data-testid="last-night-title" className="text-lg font-bold flex items-center gap-2">
        <Moon className="h-4 w-4 text-[#FFB800]" /> {data.window === "last_night" ? `Last night in ${short}` : `This week's shows in ${short}`}
      </h3>
      <p className="text-xs text-slate-500 mb-3">Fresh photos from travelers who just went</p>
      <div className="-mx-4 px-4 flex gap-3 overflow-x-auto no-scrollbar pb-2">
        {data.photos.map((ph, i) => (
          <button key={ph.url} type="button" data-testid={`last-night-photo-${i}`} onClick={() => setOpen(ph)}
            className="rise group relative shrink-0 h-56 w-40 sm:h-64 sm:w-48 rounded-2xl overflow-hidden border border-[#26334D] text-left" style={{ animationDelay: `${i * 50}ms` }}>
            <img src={imgSrc(ph.url)} alt={ph.place_name || "Show photo"} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
            {ph.rating && (
              <span className="absolute top-2 left-2 flex items-center gap-1 rounded-full bg-[#0B0F19]/80 backdrop-blur px-2 py-0.5 text-xs text-[#FFB800]">
                <Star className="h-3 w-3 fill-current" /> {ph.rating}
              </span>
            )}
            <span className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-[#0B0F19] via-[#0B0F19]/70 to-transparent p-2 text-xs">
              <span className="block font-semibold truncate">{ph.place_name}</span>
              <span className="flex items-center justify-between gap-2 text-slate-300">
                <span className="truncate">{ph.author.name}</span>
                <PhotoHeart photo={ph} canLike={ph.follows_author && !ph.is_mine} onLiked={onLiked} tid={`last-night-like-${i}`} />
              </span>
            </span>
          </button>
        ))}
      </div>
      <PhotoDialog photo={open} author={open?.author} canComment={open?.follows_author} canLike={open?.follows_author && !open?.is_mine}
        showComments={!!open?.follows_author} isMe={false} onLiked={onLiked} onClose={() => setOpen(null)} onDeleted={() => setOpen(null)} />
    </section>
  );
}
